import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  navList: {
    padding: 0,
  },
  navItem: {
    padding: [theme.spacing(1), 0],
    [theme.breakpoints.up('mobile')]: {
      '&:first-child': {
        paddingTop: 0,
      },
    },
  },
  navLink: {
    fontSize: 12,
    color: theme.palette.colors.darkBlue,
    '&:hover': {
      color: theme.palette.colors.darkBlue,
      textDecoration: 'none',
    },
    [theme.breakpoints.up('mobile')]: {
      fontSize: theme.spacing(2),
      lineHeight: '24px',
      color: theme.palette.colors.black,
      '&:hover': {
        color: theme.palette.colors.black,
      },
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/SecondaryNav/useStyles.js